export default __webpack_public_path__ + "static/media/banner.f8b7b87b.png";